import React from "react";
import { ExclamationCircleIcon } from "@heroicons/react/outline";
import { CollectionStage } from "../../types";

interface RequestAlertProps {
  notes?: string;
  stage?: CollectionStage;
}

const RequestAlert = React.memo(({ notes, stage }: RequestAlertProps) => {
  return (
    <div className="flex flex-row items-center">
      <ExclamationCircleIcon
        className="h-6 w-6 mr-2 mb-auto text-yellow-500"
        aria-hidden="true"
      />
      <div className="flex-auto m-auto">
        <h4 className="uppercase font-bold text-md text-yellow-500 ">
          {stage?.toUpperCase()}
        </h4>
        {/* <p className="text-sm font-light text-gray-500">{notes}</p> */}
      </div>
    </div>
  );
});

export default RequestAlert;
